import { ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Tab, Tabs } from '@mui/material';

export type MaterialTabItem = {
    label: ReactNode;
    disabled: boolean;
    to: string;
};

export function MaterialTab({ tabs }: { tabs: MaterialTabItem[] }) {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const activeTab = tabs.find(tab => pathname.includes(tab.to))?.to;

    return (
        <Tabs
            sx={{
                backgroundColor: theme => theme.palette.blue.light,
                flexShrink: 0,
            }}
            variant="fullWidth"
            value={activeTab ?? false}
        >
            {tabs.map(tab => (
                <Tab
                    key={tab.to}
                    label={tab.label}
                    value={tab.to}
                    disabled={tab.disabled}
                    onClick={() => navigate(tab.to)}
                    sx={{
                        padding: theme => theme.spacing(2),
                        color: theme => theme.palette.blue.main,
                        minWidth: 'auto',
                        fontSize: '16px',
                        fontWeight: 'normal',
                        '&.Mui-selected': {
                            backgroundColor: theme => theme.palette.blue.light,
                            fontWeight: 'bold',
                        },
                    }}
                />
            ))}
        </Tabs>
    );
}
